<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button autoHide="false"></ion-menu-button>
      <ion-back-button defaultHref="/driver/queue" text="" icon="chevron-back"></ion-back-button>
    </ion-buttons>
    <ion-title>In Line...</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content id="info-queue-page">
  <div style="display: none" (click)="manualCaller()" id="hiddenDiv"></div>
  <div class="top-informations">
      <div class="value-bigger">
        <span>Status Trip</span>
        <span style="color: black"
          >Waiting
          <small class="bols">
            <span>.</span>
          </small>
        </span>
      </div>
      <div class="data-user">
        <div class="ico">
          <ion-img src="assets/images/map/car_normal.png" style="width: 100%" />
        </div>
        <h3>{{user.name}}</h3>
      </div>
    </div>
  <div class="informations-complementary">
    <div class="block">
      <h4>Cars in Line</h4>
      <p><ion-icon name="car"></ion-icon> {{raceInfo.numeroCarrosFila}}</p>
    </div>
    <div class="block">
      <h4>
        Your position <br />
        in Line
      </h4>
      <div style="display: flex">
        <div style="display: flex">
          <ion-icon name="car-sport"></ion-icon>
          <ion-icon name="car"></ion-icon>
        </div>
        <p>{{raceInfo.posicaoMotoristaFila}}</p>
      </div>
    </div>
    <div class="block">
      <h4>Trips/Day</h4>
      <p>
        <ion-icon name="speedometer"></ion-icon> {{raceInfo.numerosCorridaDia}}
      </p>
    </div>
    <div class="block" (click)="goToScheduledTrips()">
      <h4>In Dispute</h4>
      <ion-icon name="alert-circle"></ion-icon>
      <p>{{ disputedTripsCount }}</p>
    </div>
  </div>
  <div class="ion-padding">
    <button class="button-bigger white animation-none" (click)="leaveLine()">
      Exit Line
    </button>
  </div>

  <div class="container-modal" [ngClass]="{'enabled': isCaller}">
    <ion-card color="light" class="ion-text-center">
      <ion-card-header>
        <ion-icon class="ico" name="notifications-outline"></ion-icon>
        <ion-card-title>You have <br />received a call!</ion-card-title>
        <h1 class="count">
          00:{{ secondsToAccept < 10 ? '0' + secondsToAccept : secondsToAccept
          }}
        </h1>
      </ion-card-header>
      <ion-grid>
        <ion-row>
          <ion-col grid-6>
            <ion-button
              shape="round"
              expand="block"
              (click)="acceptRace()"
              color="success"
            >
              <ion-icon name="checkmark"></ion-icon> Accept
            </ion-button>
          </ion-col>
          <ion-col grid-6>
            <ion-button
              fill="clear"
              shape="round"
              expand="block"
              (click)="declineRace()"
              size="small"
              color="danger"
            >
              <ion-icon name="close"></ion-icon> Decline
            </ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-card>
  </div>

  <div class="container-modal" [ngClass]="{'enabled': isCaller}">
    <ion-button
      class="button-decline"
      shape="round"
      expand="block"
      (click)="declineRace()"
      size="small"
      color="danger"
    >
      <ion-icon name="close"></ion-icon> Decline
    </ion-button>
    <ion-card color="light" *ngIf="raceRequest">
      <div
        class="bar-progress"
        [style.width.%]="(secondsToAccept / 28 ) * 100"
      ></div>
      <ion-card-header>
        <ion-card-title class="ion-text-center">
          <ion-icon class="ico" name="notifications-outline"></ion-icon>
          You have received a call!
        </ion-card-title>
      </ion-card-header>
      <ion-card-content>
        <span class="badge" *ngIf="raceRequest.dataAgendamentoCorrida">
          <ion-icon name="calendar"></ion-icon>
          Trip Scheduled {{ raceRequest.dataAgendamentoCorrida |
          date:"MM/dd/yyyy h:mm a" }}
        </span>
        <div class="infos-call">
          <strong>{{raceRequest.enderecoOrigem}}</strong>
          <h2 class="title">
            <ion-icon class="pin"></ion-icon> {{raceRequest.enderecoDestino}}
          </h2>
          <div class="bagdes">
            <div class="value-payment main">
              {{raceRequest.valorCorrida | currency}}
            </div>
          </div>
          <div class="bagdes">
            <div class="value-payment" style="font-size: 17px">
              Trip fee: {{raceRequest.repasseMotorista | currency}} -
              {{raceRequest.porcentagem}}
            </div>
          </div>
          <div class="bagdes">
            <div class="value-trip" style="font-size: 17px">
              Trip type: {{raceRequest.raceType}}
            </div>
          </div>
          <div class="bagdes">
            <div class="value" style="font-size: 17px">
              Vehicle type: {{raceRequest.vehicleType}}
            </div>
          </div>
          <div class="bagdes">
            <ion-badge color="primary" *ngIf="raceRequest?.pagaPelaPlataforma">Paid by Platform</ion-badge>
            <ion-badge color="success" *ngIf="!raceRequest?.pagaPelaPlataforma">Collect from Passenger</ion-badge>
          </div>
          <div class="bagdes">
            <div class="value" style="font-size: 17px">Languages:</div>
            <div class="flags">
              <ion-img
                *ngIf="raceRequest?.idioma?.includes(Languages.English)"
                src="assets/English.svg"
                class="ico"
                alt=""
              />
              <ion-img
                *ngIf="raceRequest?.idioma?.includes(Languages.Portuguese)"
                src="assets/Portuguese.svg"
                class="ico"
                alt=""
              />
              <ion-img
                *ngIf="raceRequest?.idioma?.includes(Languages.Spanish)"
                src="assets/Spanish.png"
                class="ico"
                alt=""
              />
              <ion-img
                *ngIf="raceRequest?.idioma?.includes(Languages.Mandarin)"
                src="assets/Mandarin.png"
                class="ico"
                alt=""
              />
              <ion-img
                *ngIf="raceRequest?.idioma?.includes(Languages.French)"
                src="assets/French.png"
                class="ico"
                alt=""
              />
              <ion-img
                *ngIf="raceRequest?.idioma?.includes(Languages.Italian)"
                src="assets/Italian.png"
                class="ico"
                alt=""
              />
              <ion-img
                *ngIf="raceRequest?.idioma?.includes(Languages.Japanese)"
                src="assets/Japanese.png"
                class="ico"
                alt=""
              />
              <ion-img
                *ngIf="raceRequest?.idioma?.includes(Languages.Arabic)"
                src="assets/Arabic.png"
                class="ico"
                alt=""
              />
              <ion-img
                *ngIf="raceRequest?.idioma?.includes(Languages.German)"
                src="assets/German.png"
                class="ico"
                alt=""
              />
              <ion-img
                *ngIf="raceRequest?.idioma?.includes(Languages.Russian)"
                src="assets/Russian.png"
                class="ico"
                alt=""
              />
              <ion-img
                *ngIf="raceRequest?.idioma?.includes(Languages.Vietnamese)"
                src="assets/Vietnamese.png"
                class="ico"
                alt=""
              />
            </div>
          </div>
        </div>
        <button
          class="button-bigger grey margin-top"
          [disabled]="secondsToAccept < 0"
          (click)="acceptRace()"
        >
          <div style="display: flex; justify-content: center">
            <span class="acceptText">Accept</span>
          </div>
        </button>
      </ion-card-content>
    </ion-card>
  </div>
</ion-content>
